import { combineReducers } from 'redux';

import AuthenticationReducer from '../../components/authentication/AuthenticationReducer';
import HomePageReducer from '../../components/home-page/home-page-store/HomePageReducer';
import VTOReducer from '../../components/VTO/VTOReducer';
// import OvertimeReducer from '../../components/OT-Comp/OvertimeReducer';
import OvertimeReducer from '../../components/OT-Comp/OvertimeReducerNormalized';

const rootReducer = combineReducers({
    AuthenticationReducer,
    HomePageReducer,
    VTOReducer,
    OvertimeReducer
});

export default rootReducer;